
<ng-container *ngIf="validation" >
    <div class="status" *ngIf="statusId == 1 || statusId == 2 || statusId == 3">
        <img
            matTooltip="Estamos validando a Informação!"
            matTooltipPosition="above"
            class="waiting"
            src="./assets/icons/clock.svg">
    </div>
    <div class="status" *ngIf="statusId == 4">
        <img
            matTooltip="Informação não verificada! Edite e verifique."
            matTooltipPosition="above"
            class="error"
            src="./assets/icons/x-circle.svg">
    </div>
    <div class="status" *ngIf="statusId == 5">
        <img
            matTooltip="Informação válida!"
            matTooltipPosition="above"
            class="validated"
            src="./assets/icons/check-circle.svg">
    </div>
</ng-container>
